import React from 'react';
import cbaLogo from '../Photos/cba-LOGOS-green-300x154-1.png';

function Footer() {
  return (
    <footer id="contact" className="bg-black py-12">
      <div className="container mx-auto px-4 flex justify-between items-center text-neutral-400">
        <div className="text-left">
            <p className="text-lg font-montserrat font-bold tracking-wider">BRICK & CLAY</p>
            <p className="mt-2 text-sm">Building cornerstones since 1969.</p>
            <div className="mt-6">
              <a href="https://www.facebook.com/nigelbricksales/" target="_blank" rel="noopener noreferrer" className="flex items-center hover:underline">
                <img src={require('../Photos/facebook-logo.svg').default} alt="Facebook Logo" className="w-6 h-6 mr-2" />
                Nigel Brick and Clay
              </a>
            </div>
            <p className="mt-8 text-xs text-neutral-500">&copy; 2024 Brick & Clay. All Rights Reserved.</p>
        </div>
        <div>
            <img src={cbaLogo} alt="CBA Member Logo" className="h-24"/>
        </div>
      </div>
    </footer>
  );
}

export default Footer;